import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import intl from 'react-intl-universal';

const propTypes = {
  goToPrevCase: PropTypes.func.isRequired,
  goToNextCase: PropTypes.func.isRequired,
  hasPrevCase: PropTypes.bool.isRequired,
  hasNextCase: PropTypes.bool.isRequired,
};

const ViewerToolArea = ({
  goToPrevCase,
  goToNextCase,
  hasPrevCase,
  hasNextCase,
}) => {
  return (
    <Fragment>
      <Grid container justifyContent="space-between">
        <Grid>
          <Button
            data-testid="assignment-viewer-button-prev"
            variant="contained"
            color="primary"
            onClick={goToPrevCase}
            disabled={!hasPrevCase}
            sx={{
              backgroundColor: '#54C6B8', // Set the background color to light blue
              color: '#fff', // Set the text and icon color to white
              '&:hover': { backgroundColor: '#06F8DC' },
              margin: '0px 2px 0px 6px',
              fontSize: '14.5px', // text size
            }}
            startIcon={<NavigateBeforeIcon />}>
            {intl.get('kenshin_assignment_viewer_button_prev')}
          </Button>
        </Grid>
        <Grid>
          <Button
            data-testid="assignment-viewer-button-next"
            variant="contained"
            color="primary"
            onClick={goToNextCase}
            disabled={!hasNextCase}
            sx={{
              backgroundColor: '#0052cc', // Set the background color to light blue
              color: '#fff', // Set the text and icon color to white
              '&:hover': { backgroundColor: '#005ae0' },
              margin: '0px 2px 0px 6px',
              fontSize: '14.5px', // text size
            }}
            endIcon={<NavigateNextIcon />}>
            {intl.get('kenshin_assignment_viewer_button_next')}
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

ViewerToolArea.propTypes = propTypes;

export default ViewerToolArea;
